import { useState, useEffect, useRef } from 'react';
import './App.scss';
import Sidenav from "./components/Sidenav";
import Header from "./components/MobileHeader";
import ChatPage from "./ChatPage";
import axios from "axios";

function Home() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const chatPageRef = useRef();
  const navPageRef = useRef();
  const [spinner, setSpinner] = useState(true);
  const [isGuest, setIsGuest] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    checkLoginGuest();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const checkLoginGuest = async () => {
    try {
      let token = localStorage.getItem('stadata-token');
      let guestId = localStorage.getItem('stadata-guest-id') || '0';
      if (!token) {
        setIsGuest(true);
        let headers = {
          "Content-Type": "application/json",
        };
        const apiUrl = `${process.env.REACT_APP_API_URL}/auth/guest/${guestId}`;
        const response = await axios.get(apiUrl, { headers: headers });
        if (response?.data?.token) {
          console.log('response', response);
          localStorage.setItem("stadata-token", response?.data?.token);
          localStorage.setItem("stadata-auth", JSON.stringify(response?.data));
          localStorage.setItem("stadata-guest-id", response?.data['UserID']);
          localStorage.setItem("stadata-guest-session", true);
        }
      } else {
        let isG = localStorage.getItem("stadata-guest-session");
        setIsGuest(isG);
      }
      setSpinner(false);
    } catch(error) {
      setSpinner(false);
      console.error("Error:", error);
    }
  }

  const startNewChat = () => {
    if (chatPageRef.current) {
      chatPageRef.current.startNewChat();
    }
  }

  const loadPreviousChat = (item) => {
    if (chatPageRef.current) {
      chatPageRef.current.loadPreviousChat(item);
    }
  }

  const refreshNav = () => {
    if (navPageRef.current) {
      setTimeout(() => {
        navPageRef.current.fetchHistory();
      }, 500);
    }
  }

  return (
    <div>
      { spinner ? (
        <div>
          <div className="flex justify-center absolute left-1/2 top-1/2 transform -translate-x-1/2">
            <div className="w-6 h-6 border-4 border-t-4 border-t-blue-500 border-gray-200 rounded-full animate-spin" style={{width: "80px", height: "80px"}}></div>
          </div>
        </div>
      ) : (
        <div className="flex h-screen">
          <div>
            <Sidenav
              sidebarOpen={isSidebarOpen}
              setSidebarOpen={setSidebarOpen}
              startNewChat={startNewChat}
              loadPreviousChat={loadPreviousChat}
              isGuest={isGuest}
              ref={navPageRef}
            />
          </div>
          <div className="relative flex flex-col flex-1 lg:overflow-y-auto lg:overflow-x-hidden">
            {isMobile && (
              <Header
                setSidebarOpen={setSidebarOpen}
                className="sticky top-0 border-b border-slate-200 z-30"
              />
            )}
            <main>
              <ChatPage ref={chatPageRef} refreshNav={refreshNav} isGuest={isGuest} />
            </main>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
